export const redirectTo = (url: string) => {
  window.location.href = url;
};

export const pushState = (url: string) => {
  if (window?.history?.pushState) {
    window.history.pushState({ path: url }, '', url);
  } else {
    redirectTo(url);
  }
};

export const openInNewTab = (url: string) => {
  window.open(url, '_blank')?.focus();
};
